'use client'

import type { FunctionComponent } from 'react'
import styles from './YoutubeEmbed.module.sass'

export interface YouTubeEmbedProps {
	url: string
	width?: number
	height?: number
}

const getEmbedUrl = (url: string): string => {
	try {
		const parsedUrl = new URL(url)
		if (parsedUrl.hostname === 'youtu.be') {
			const videoId = parsedUrl.pathname.slice(1)
			return `https://www.youtube.com/embed/${videoId}`
		}
		if (parsedUrl.hostname.includes('youtube.com')) {
			if (parsedUrl.pathname.includes('/embed/')) {
				return url
			}
			if (parsedUrl.pathname === '/watch') {
				const videoId = parsedUrl.searchParams.get('v')
				return videoId ? `https://www.youtube.com/embed/${videoId}` : url
			}
		}
	} catch (error) {
		console.error('Invalid URL', error)
	}
	return url
}

export const YouTubeEmbed: FunctionComponent<YouTubeEmbedProps> = ({ url, width = 16, height = 9 }) => {
	const embedUrl = getEmbedUrl(url)
	return (
		<div
			className={styles.wrapper}
			style={
				{
					'--YouTube-width': width,
					'--YouTube-height': height,
				} as React.CSSProperties
			}
		>
			<iframe
				className={styles.iframe}
				src={embedUrl}
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			></iframe>
		</div>
	)
}
